import type { AtividadeEmpresa, AtividadesDto } from '@triade/contracts';
import { useSessao } from '@/lib/session';
import { useMutacao } from './base';
import { useEmpresas } from './me';

/**
 * Perfil de atividade da empresa escolhida, lido de GET /me/empresas (so exibicao: menu e tipos de item).
 * `undefined` enquanto carrega ou sem empresa: quem recebe trata como "mostra tudo" (nada some por falta de dado).
 */
export function useAtividadesDaEmpresa(): AtividadeEmpresa[] | undefined {
  const { empresaId } = useSessao();
  const empresas = useEmpresas();
  if (empresaId === null || !empresas.data) return undefined;
  return empresas.data.find((e) => e.id === empresaId)?.atividades;
}

/** PUT /empresa/atividades (ao menos uma; 403 sem parametros.editar). Invalida /me/empresas para o menu e os tipos refletirem. */
export function useSalvarAtividades() {
  return useMutacao<AtividadesDto, AtividadeEmpresa[]>({
    metodo: 'PUT',
    caminho: () => '/empresa/atividades',
    corpo: (atividades) => ({ atividades }),
    invalidar: [['me', 'empresas']],
  });
}
